import React from 'react';

export function ArrowWaterDown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="60" fill="none" viewBox="0 0 30 84">
      <path
        fill="#000000"
        d="M13.586 83.414a2 2 0 002.828 0l12.728-12.728a2 2 0 10-2.828-2.828L15 79.172 3.686 67.858a2 2 0 10-2.828 2.828l12.728 12.728zM17 2a2 2 0 10-4 0h4zm0 80V2h-4v80h4z"
      />
    </svg>
  );
}
